import { render } from "./Generalnformation.vue?vue&type=template&id=0a0b28d4&scoped=true"
import script from "./Generalnformation.vue?vue&type=script&lang=js"
export * from "./Generalnformation.vue?vue&type=script&lang=js"

import "./Generalnformation.vue?vue&type=style&index=0&id=0a0b28d4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a0b28d4"]])

export default __exports__